import React from "react";
import ReactDOM from "react-dom";
import Aux from './hoc/Auxiliary';
import ModWebParts from './containers/ModWebParts';

//main container component
const App = (props) => {
        return <ModWebParts webPartProperties={props.webPartProperties} />
}
export default App;
 
